import React from 'react';

const FormInput = props => {
  return (
    <div className="contact__form--input">
      <input
        type={props.type}
        id={props.id}
        placeholder={props.placeholder}
        required={props.required}
        name={props.name}
      />
      <label htmlFor={props.id}>{props.placeholder}</label>
    </div>
  );
};

export default FormInput;



// WEBPACK FOOTER //
// ./src/components/Contact/FormInput/FormInput.js